/**
 * Funkcija koja formatira sedišta i postavlja ih u raspored 2 po 2.
 * @param {Array} vehicleSeats - Niz objekata sedišta za JEDNO vozilo.
 * @param {Boolean} isSelfSale - Da li je sopstvena prodaja.
 */

export const formatAndLayoutSeats = (vehicleSeats, isSelfSale) => {

    const SEAT_STATUS = {
        AVAILABLE: 'AVAILABLE',
        OCCUPIED: 'OCCUPIED',
        RESERVED: 'RESERVED',
        DISABLED: 'DISABLED',
    };


    // Ako je sopstveni prevoz, proveriti da li postoji bar jedan alotman
    // Ako postoji - prikazujemo samo sedista sa alotmanom (isto kao nesopstveni prevoz)
    const hasAnyAllotment = isSelfSale && vehicleSeats.some(s => s.alId);

    const formattedSeats = vehicleSeats.map(seatData => {
        let status = SEAT_STATUS.AVAILABLE;
        // Sedište pripada alotmanu drugog operatera (backend računa po allotment_operator).
        // Kada polje ne postoji (stariji odgovor / javni kontekst) ponašanje ostaje kao ranije.
        if (seatData?.selectableByCurrentOperator === false) {
            status = SEAT_STATUS.DISABLED;
        } else if ((isSelfSale === false || hasAnyAllotment) && !seatData?.alId) {
            status = SEAT_STATUS.DISABLED;
        } else if (seatData.occupied || seatData.reservationExpireSec > 180) {
            // DODATO 180 jer procedura get_trip_seats occupied vraca  true samo ako ima sales_dt...
            status = SEAT_STATUS.OCCUPIED;
        } else if (seatData.reserved) {
            status = SEAT_STATUS.RESERVED;
        }
        return {id: seatData.seat, status: status, reservationExpireSec: seatData.reservationExpireSec, passengerId: seatData?.passengerId};
    });

    formattedSeats.sort((a, b) => a.id - b.id);

    const layout = [];
    for (let i = 0; i < formattedSeats.length; i += 4) {
        if (formattedSeats[i]) layout.push(formattedSeats[i]);
        if (formattedSeats[i + 1]) layout.push(formattedSeats[i + 1]);
        layout.push(null); // Prolaz
        if (formattedSeats[i + 2]) layout.push(formattedSeats[i + 2]);
        if (formattedSeats[i + 3]) layout.push(formattedSeats[i + 3]);
    }
    return layout;
};
